import i18next from "i18next";
import React from "react";
import { SimpleHeaderPropTypes } from "./types";
import useBrowserCheck from "~/assets/js/Helpers/hooks/useBrowserCheck";

const SimpleHeader = ({
    rightSide,
    onBackClick,
    showBack = true,
    showArrow = true,
    backText = "header.back",
}) => {
    const browser = useBrowserCheck();

    const logoDefined =
        typeof reactConfig !== "undefined" && reactConfig.logoUrl;

    return (
        <header
            id="header"
            style={{ position: browser.isSafari ? "inherit" : "sticky" }}
        >
            <div className="wrapper">
                {showBack && (
                    <span onClick={onBackClick}>
                        {showArrow && <i className="fas fa-chevron-left"></i>}
                        {i18next.t(backText)}
                    </span>
                )}
            </div>
            <div className="wrapper">
                {logoDefined && (
                    <img
                        id="pottsalat-logo"
                        src={reactConfig?.logoUrl}
                        alt="pottsalat-logo"
                    />
                )}
            </div>
            <div className="wrapper">{rightSide ? rightSide : <div></div>}</div>
        </header>
    );
};

SimpleHeader.propTypes = SimpleHeaderPropTypes;
export default SimpleHeader;
